import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-row nowrap body align-items-md-start mb-2 mb-md-3 mb-lg-2 text-start justify-content-md-start"
}
const _hoisted_2 = { class: "me-2 d-md-flex d-none align-items-center" }
const _hoisted_3 = ["height", "width"]
const _hoisted_4 = ["xlink:href"]
const _hoisted_5 = { class: "me-2 d-flex d-md-none align-items-center" }
const _hoisted_6 = ["height", "width"]
const _hoisted_7 = ["xlink:href"]
const _hoisted_8 = { class: "d-flex align-items-center gap-1" }
const _hoisted_9 = { class: "caption text-grey-700 d-flex align-items-center" }
const _hoisted_10 = ["height", "width"]
const _hoisted_11 = ["height", "width"]
const _hoisted_12 = { key: 1 }

import { computed, watch } from 'vue'
import { useStore } from 'vuex'
import PlaceholderBox from '@/vue/planning/components/common/placeholderBox.vue'
import iconSizes from '@/config/iconSizes'
import packOptionsConfig from '@/config/packOptionsConfig'
import getServiceDuration from '@/vue/planning/logic/getServiceDuration'

interface Variant {
	codePackage?: string
	skipass?: string | number
}

interface Props {
	isDisplayPlaceholders?: boolean
	isPierreVacance?: boolean
	variant?: Variant
}


export default /*@__PURE__*/_defineComponent({
  __name: 'inclus',
  props: {
    isDisplayPlaceholders: { type: Boolean, default: false },
    isPierreVacance: { type: Boolean, default: false },
    variant: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props

const store = useStore()

const content = computed(() => store.state.content)
const participants = computed(() => store.state.participants as number[])
const flightPackCodeSelected = computed(() => store.getters.flightPackCodeSelected)
const locale = computed(() => store.getters.locale as string)

const packCode = computed(() => props.variant?.codePackage ?? '')

const iconSize = iconSizes.l
const iconSize_adult = iconSizes.l
const iconSize_child = iconSizes.s

const currentPackConfig = computed(() => {
	return (packOptionsConfig as Record<string, string[]>)[packCode.value] || []
})

const participantsLength_adults = computed(() => {
	return participants.value.filter((age) => age >= 18).length
})

const participantsLength_children = computed(() => {
	return participants.value.filter((age) => age < 18 && age > 1).length
})

function getLabel(optionName: string): string {
	let contentVariable = `planningSummary_options_${optionName}`
	if (optionName === 'transport' && flightPackCodeSelected.value) {
		contentVariable += '_flight'
	}
	return content.value[contentVariable]
}

watch(
	() => props.variant?.codePackage,
	() => {
		// Package change handling if needed in the future
	},
	{ immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (
			(currentPackConfig.value && currentPackConfig.value.length > 0) ||
			_ctx.isDisplayPlaceholders
		)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (
				currentPackConfig.value &&
				currentPackConfig.value.length > 0 &&
				!_ctx.isDisplayPlaceholders
			)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["d-flex flex-wrap justify-content-between justify-content-md-start", !_ctx.isPierreVacance && 'flex-md-column'])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentPackConfig.value, (optionName, option_i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: option_i,
                  class: "me-2 me-md-3 text-nowrap mb-2 mb-md-1 d-flex flex-row nowrap align-items-center"
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    (_openBlock(), _createElementBlock("svg", {
                      height: _unref(iconSize),
                      width: _unref(iconSize),
                      class: "icon"
                    }, [
                      _createElementVNode("use", {
                        "xlink:href": `#___icon___${optionName}`
                      }, null, 8, _hoisted_4)
                    ], 8, _hoisted_3))
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(), _createElementBlock("svg", {
                      height: _unref(iconSize),
                      width: _unref(iconSize),
                      class: "icon text-primary-blue"
                    }, [
                      _createElementVNode("use", {
                        "xlink:href": `#___icon___${optionName}`
                      }, null, 8, _hoisted_7)
                    ], 8, _hoisted_6))
                  ]),
                  _createElementVNode("span", _hoisted_8, [
                    _createTextVNode(_toDisplayString(getLabel(optionName)) + " ", 1),
                    _createElementVNode("span", _hoisted_9, [
                      (optionName !== 'night' && !(optionName === 'home' && locale.value === 'en_US'))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(`(${participantsLength_adults.value}`) + " ", 1),
                            (_openBlock(), _createElementBlock("svg", {
                              height: _unref(iconSize_adult),
                              width: _unref(iconSize_adult),
                              class: "icon",
                              style: {"margin-bottom":"2px"}
                            }, _cache[0] || (_cache[0] = [
                              _createElementVNode("use", { "xlink:href": "#___icon___person" }, null, -1)
                            ]), 8, _hoisted_10)),
                            (participantsLength_children.value > 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString("+") + " " + _toDisplayString(participantsLength_children.value) + " ", 1),
                                  (_openBlock(), _createElementBlock("svg", {
                                    height: _unref(iconSize_child),
                                    width: _unref(iconSize_child),
                                    class: "icon"
                                  }, _cache[1] || (_cache[1] = [
                                    _createElementVNode("use", { "xlink:href": "#___icon___person" }, null, -1)
                                  ]), 8, _hoisted_11))
                                ], 64))
                              : _createCommentVNode("", true),
                            (optionName !== 'transport' && optionName !== 'flight')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(`, ${_unref(getServiceDuration)(optionName) || _ctx.variant.skipass} ${content.value.days})`), 1))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode(_toDisplayString(`)`))
                                ], 64))
                          ], 64))
                        : (optionName === 'home' && locale.value === 'en_US')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(`(${Math.min(Number(_unref(getServiceDuration)(optionName) || _ctx.variant.skipass), 7) || ''} ${content.value.planner_nights})`), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [], 64))
                    ])
                  ])
                ]))
              }), 128))
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.isDisplayPlaceholders)
          ? (_openBlock(), _createBlock(PlaceholderBox, {
              key: 1,
              minHeight: '25px'
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})